import slice from "./loggerSlice";

export default slice.reducer;
